import React from 'react';

const AuditFooter = () => {
    const currentYear = new Date().getFullYear();
    
    return (
        <footer className="bg-[#f6f3ee] border-t border-[#085e53]/10 py-6 px-8 mt-auto z-40 relative">
            <div className="max-w-[1600px] mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
                <div className="text-gray-500 text-sm font-medium">
                    © Copyright {currentYear} <span className="text-[#085e53] font-bold">Zilla Parishad Sangli</span>. 
                    All Rights Reserved.
                </div>
                <div className="flex items-center gap-2">
                    <span className="text-gray-400 text-[12px] font-bold uppercase tracking-wider">
                        Design & Developed by
                    </span>
                    <span className="bg-[#085e53]/10 text-[#085e53] px-3 py-1 rounded-full text-[11px] font-black uppercase tracking-widest border border-[#085e53]/20">
                        Zilla Parishad
                    </span>
                </div>
            </div>
        </footer>
    );
};

export default AuditFooter;
